module.exports = __webpack_public_path__ + "static/media/54pic.985b34b1.jpg";